<div class="stats-wrapper" #statsWrapper *ngIf="stats">
  <ul>
    <li>
      <span class="stat-number" [countUp]="stat1Number$ | async" duration="1500">255</span>
      <span class="stat-label" [innerHtml]="getStatText(stats.stat1.label)"></span>
    </li>
    <li>
      <span class="stat-number" [countUp]="stat2Number$ | async" duration="1500"></span>
      <span class="stat-label" [innerHtml]="getStatText(stats.stat2.label)"></span>
    </li>
    <li>
      <span class="stat-number" [countUp]="stat3Number$ | async" duration="1500"></span>
      <span class="stat-label" [innerHtml]="getStatText(stats.stat3.label)"></span>
    </li>
  </ul>
</div>